module.exports = __webpack_public_path__ + "static/media/canigrowlogo2.78e3785d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/canigrowlogo2.png
// module id = 542
// module chunks = 0